import React, { PureComponent } from "react";
import { connect } from 'react-redux';
import PopUpHelper from '../../../Calculations/popUpHelper.component';
import { generatePipeDesign } from "../../../../actions/pipe-bed-actions";
import { DefaultButton } from 'office-ui-fabric-react/lib-commonjs/Button';
import { SpinButton } from 'office-ui-fabric-react/lib-commonjs/SpinButton';
import {
    setPipeParameterValue,
    switchThermoplasticLinter
} from '../../../../actions/pipe-calculations.actions';
import {
    pipeSizes,
    pipeFittings,
} from '../../../../lib/pipe-dataset';
import {
    METRIC,
    IMPERIAL,
    PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID,
} from '../../../../lib/types';
import pipeSelectors from "../../../../lib/pipe-selectors";
import { switchIsSigningInProcess } from '../../../../actions/authentication-actions';
import './index.css';
import ProjectSelectors from "../../../../reducers/project-reducer";
import { setOverallTotal } from "../../../../actions/multi-bed-actions";

class PipeParametersComponent extends PureComponent {
    state = {
        pipeFitting: {}, // used for session persistence
        newPipeNominalDiameter: null,
        showGenerateAlert: false
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ( // Apply fittings to local state to control session persistence
            this.props.sysParam["pipeFitting"].value._name !== prevProps.sysParam["pipeFitting"].value._name &&
            this.props.sysParam["pipeFitting"].touched &&
            this.props.sysParam["pipeFitting"].active
        ) {
            this.setState({ "pipeFitting": this.props.sysParam["pipeFitting"].value });
        }

        if (this.props.pipeFitting._name !== prevProps.pipeFitting._name)
            this.setState({ "pipeFitting": this.props.pipeFitting });

        // If chamber type/underdrain has changed, set the constraints
        const hasChamberTypeChanged = this.anyPropHasChanged(prevProps, ["chamberType"]);
        const hasUnderdrainChanged = this.anyPropHasChanged(prevProps, ["underdrain"]);

        if (hasChamberTypeChanged || hasUnderdrainChanged) {
            this.props.setConstraints(this.props.chamberType, this.props.underdrain, hasChamberTypeChanged);
        }

        if (
            this.anyPropHasChanged(prevProps, [
                "stoneBedPoints",
                "manifoldPipeSizes"])
        ) {
            const { storageVolume, totalStorageProvided } = this.props;
            this.props.applyManifoldSeparations(totalStorageProvided || storageVolume);
        }

        /* the properties to be checked */
        let names = [
            /* external components properties */
            "stoneBedPoints",
            "manifoldPipeSizes"
        ];

        /* the chamber rows property */
        let chamberRows = this.props.chamberRows;

        /* if any of the 'names' fields have changed, recompute calculations */
        if (
            this.anyPropHasChanged(prevProps, names) &&
            chamberRows.length &&
            chamberRows[0].getActiveCount &&
            this.props.stoneBedPoints.length
        ) {
            setTimeout(() => {
                this.executeAutoCalculations();
            }, 0);
        }

        if (this.anyPropHasChanged(prevProps, ["optimizeVolume"])) {
            if (this.props.optimizeVolume) {
                this.props.applyManifoldSeparations(this.props.storageVolume);
                this.optimizePerChamber()
                    .then(optimizedStorageVolume => {
                        if (optimizedStorageVolume < this.props.storageVolume) {
                            this.showModal();
                        }
                    })
                    .then(() => this.props.endVolumeOptimizer())  // FIXME: Should be a finally() call
                    .catch(error => console.warn("There was a problem optimizing the system", error));
            }
            this.setState({
                optimizing: this.props.optimizeVolume
            });
        }

        // controls that the objects on systemParams are copied as they needed to calculations when chamberType changes

        const setStoreValuesSyncOnSwitch = (sysSetting) => {
            const sysParamObj = this.props.sysParam[sysSetting];
            if (
                typeof sysParamObj === "object" &&
                sysParamObj.sync === true
            ) {
                const syncToSysParamObj = this.props.sysParam[sysParamObj.syncTo];
                if (
                    syncToSysParamObj.touched === true &&
                    syncToSysParamObj.stamp > sysParamObj.stamp && //Timestamp has to be higher on SyncTo
                    sysParamObj.value !== syncToSysParamObj.value &&
                    sysParamObj.type === "pipe"
                ) {
                    this.props.setPipeParameterValue(sysSetting, syncToSysParamObj.value);
                }
            }
        };
        for (const param in this.props.sysParam) {
            setStoreValuesSyncOnSwitch(param)
        }
    }

    componentDidMount() {
        this.setState({ 'pipeFitting': this.props.pipeFitting })
    }

    /**
     * This method receives the previous properties object and an Array of
     * the properties to be determined if have changed and returns true if any
     * have changed, or false if all are the same.

     * @param {Object} prevProps The previous properties of the component.
     * @param {Array<string>} propNames The Properties names array.
     */
    anyPropHasChanged(prevProps, propNames) {
        let changed = false;
        for (let name of propNames) {
            changed = this.props[name] !== prevProps[name] || changed;
        }
        return changed;
    }

    handleDropdowns(reducer, data, evt, ths) {
        setTimeout(() => {
            console.log(' this.setState({\'pipeFitting\'  ... executed ')
            if (reducer === 'pipeFitting') {
                this.setState({ 'pipeFitting': data.getById(ths.key) });
            }
        }, 0)
        if (reducer === 'pipeNominalDiameter') {
            this.setState({
                newPipeNominalDiameter: data.getByNominalDiameter(ths.key),
                showGenerateAlert: true
            });
        } else {
            this.props.setPipeParameterValue(reducer, data.getById(ths.key));
        }
    };

    roundNumber(num) {
        return Math.round(num * 100) / 100;
    }

    timesUnits(unitType, change) {
        let newVal = 0;
        switch (unitType) {
            case 'ft':
                return newVal = (3.28084 * change);
            case 'in':
                return newVal = (0.0393701 * change);
            default:
                return newVal;
        }
    }

    /**
     * Changes the fitting names for values
     * @param name
     * @returns {string|*}
     */
    changeFittingNames(name) {
        const content = this.props.content;
        const lang = this.props.lang;

        switch (name) {
            case 'Soil Tight':
                return content[lang].soilTight;
            case 'Soil Tight Perforated':
                return content[lang].soilTightPerforated;
            case 'Water Tight':
                return content[lang].waterTight;
            case 12:
                return this.props.unit === METRIC ? '300 mm' : name;
            case 15:
                return this.props.unit === METRIC ? '375 mm' : name;
            case 18:
                return this.props.unit === METRIC ? '450 mm' : name;
            case 24:
                return this.props.unit === METRIC ? '600 mm' : name;
            case 30:
                return this.props.unit === METRIC ? '750 mm' : name;
            case 36:
                return this.props.unit === METRIC ? '900 mm' : name;
            case 42:
                return this.props.unit === METRIC ? '1050 mm' : name;
            case 48:
                return this.props.unit === METRIC ? '1200 mm' : name;
            case 60:
                return this.props.unit === METRIC ? '1500 mm' : name;
            default:
                return name;
        }
    }

    convertUnitsForDisplay(value, unitType) {
        let unitValue = 0;
        switch (this.props.unit) {
            case METRIC:
                switch (unitType) {
                    case 'ft': // Feet to meters
                        unitValue = parseFloat(Math
                            .round((value * 0.3048) * 100) / 100)
                            .toFixed(2)
                        break;
                    case 'in': // Inches to milimeters
                        unitValue = Math
                            .round(Math
                                .round((value * 25.4) * 100) / 100);
                        break;
                    case 'cf': // Cubic feet to cubic meters
                        unitValue = parseFloat(Math
                            .round((value / 35.315) * 100) / 100)
                            .toFixed(2)
                        break;
                    default:
                        unitValue = Math
                            .round(value * 100) / 100;
                        break;
                }
                break;
            case IMPERIAL:
                unitValue = value;
                break;
            default:
                break;
        }
        return unitValue;
    }

    handleParameterValueChange(param, lowBound, highBound, change, unitType) {
        console.log(change);
        /* get scale feet unit */
        change = this.props.unit === METRIC
            ? this.timesUnits(unitType, change)
            : change;

        const value = this.roundNumber(this.props[param] + change);

        /* if change is in bounds, compute and return */
        if (lowBound <= value && value <= highBound) {
            this.props.setPipeParameterValue(param, value);
        } else if (value < lowBound) {
            this.props.setPipeParameterValue(param, lowBound);
        } else {
            this.props.setPipeParameterValue(param, highBound);
        }
    }

    handleOverallValueOnValidate(
      lowBound,
      highBound,
      parseFunc,
      unitType,
      value
    ) {
        if (isNaN(value)) {
            return `${this.convertUnits(this.props.multibedOverallSiteVolume, unitType)}`;
        }

        const allowsThreeDecimals =
          this.props.unit === METRIC;

        value =
          this.props.unit === METRIC
            ? parseFunc(value)
            : this.roundNumber(parseFunc(value));

        let newVal = this.convertUnits(
          value,
          unitType,
          allowsThreeDecimals ? 3 : null
        );

        this.props.setOverallTotal(newVal);

        let displayResult = this.convertUnits(
          newVal,
          unitType,
          allowsThreeDecimals ? 3 : null
        );
        return `${displayResult}`;
    }

    convertUnits(value, unitType) {
        let unitValue = 0;
        switch (this.props.unit) {
            case METRIC:
                switch (unitType) {
                    case 'ft': // Feet to meters
                        return parseFloat(
                            (Math.round((value * 0.3048) * 1000) / 1000).toString()
                        ).toFixed(2);
                    case 'in': // Inches to millimeters
                        return Math.round(Math.round((value * 25.4) * 100) / 100);
                    case 'cf': // Cubic feet to cubic meters
                        return parseFloat(
                            (Math.round((value / 35.315) * 100) / 100).toString()
                        ).toFixed(2);
                    default:
                        return Math.round(value * 100) / 100;
                }
            case IMPERIAL:
                return value;
            default:
                break;
        }
        return unitValue;
    }

    handleParameterValueOnValidate(param, lowBound, highBound, parseFunc, unitType, value) {
        if (isNaN(value)) {
            return `${this.convertUnitsForDisplay(this.props[param], unitType)}`;
        }

        let newVal = this.convertUnits(value, unitType);

        if (lowBound <= newVal && newVal <= highBound) {
            // value = value; // this code was doing nothing here (org Huerta)
        } else if (newVal < lowBound) {
            newVal = lowBound;
        } else {
            newVal = highBound;
        }
        setTimeout(() => {
            this.props.setPipeParameterValue(param, newVal)
        }, 0);
        return `${this.convertUnitsForDisplay(newVal, unitType)}`;
    }

    /**
     * Renders the main fields on the screen
     * @param {string|number} param
     * @param {*} label
     * @param {number} step
     * @param {*} parseFunc
     * @param {boolean} disable
     * @param {*} text
     * @param {null} image
     * @param {number} minVal
     * @param {number} maxVal
     * @param {*} unitType
     * @returns {*}
     */
    renderConstrainedParam(param, label, step, parseFunc, disable, text, image, minVal, maxVal, unitType) {
        let mainValue = 0;

        const clear = (
            this.props.sysParam &&
            this.props.sysParam['loadedProject'] === true &&
            this.props.sysParam['touchedPipes'] === false
        );

        if (
            param === 'pipeRequiredVolume' &&
            this.props.sysParam['storageVolume'].touched &&
            this.props.sysParam['storageVolume'].stamp > this.props.sysParam['pipeRequiredVolume'].stamp
        ) {
            mainValue = this.props.sysParam['storageVolume'].value;
        } else if (
            param === 'pipeAvailableLength' &&
            this.props.sysParam['availableLength'].touched &&
            this.props.sysParam['availableLength'].stamp > this.props.sysParam['pipeAvailableLength'].stamp
        ) {
            mainValue = this.props.sysParam['availableLength'].value;
        } else if (
            param === 'pipeAvailableWidth' &&
            this.props.sysParam['availableWidth'].touched &&
            this.props.sysParam['availableWidth'].stamp > this.props.sysParam['pipeAvailableWidth'].stamp
        ) {
            mainValue = this.props.sysParam['availableWidth'].value;
        } else if (
            param === 'pipeStonePorosity' &&
            this.props.sysParam['porosityPercent'].touched &&
            this.props.sysParam['porosityPercent'].stamp > this.props.sysParam['pipeStonePorosity'].stamp
        ) {
            mainValue = this.props.sysParam['porosityPercent'].value;
        } else {
            if (this.props.sysParam[param].touched && this.props.sysParam[param].active) {
                mainValue = this.props.sysParam[param].value;
            } else {
                mainValue = this.props[param];
            }
        }

        if (clear) {
            mainValue = this.props[param];
        }

        return (
            <div className="ms-Grid-row" style={css.padding_class}>
                <div
                    style={disable ? { color: 'gray' } : null}
                    className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6"
                > {label} </div>
                <div className="ms-Grid-col ms-md12 ms-lg12 ms-xl6 ms-xxl6" style={{ display: 'flex' }}>
                    <SpinButton
                        step={step}
                        min={minVal}
                        max={maxVal}
                        className={'hide-arrows'}
                        disabled={disable}
                        styles={{
                            inputDisabled: {
                                backgroundColor: '#d9d9d6',
                                color: 'white'
                            },
                            arrowButtonsContainerDisabled: {
                                backgroundColor: '#d9d9d6',
                            },
                            spinButtonWrapperDisabled: {
                                backgroundColor: '#d9d9d6'
                            }
                        }}
                        value={`${this.convertUnits(mainValue, unitType) || 0}`}
                        onIncrement={this.handleParameterValueChange
                            .bind(
                                this,
                                param,
                                minVal,
                                maxVal,
                                step,
                                unitType
                            )}
                        onDecrement={this.handleParameterValueChange
                            .bind(
                                this,
                                param,
                                minVal,
                                maxVal,
                                -step,
                                unitType
                            )}
                        onValidate={this.handleParameterValueOnValidate
                            .bind(
                                this,
                                param,
                                minVal,
                                maxVal,
                                parseFunc,
                                unitType
                            )}
                    />
                    &nbsp;
                    <PopUpHelper
                        text={text}
                        title={label}
                        image={image}
                    />
                </div>
            </div>
        );
    }

    renderOverallSiteVolume(
      label,
      step,
      parseFunc,
      disable,
      text,
      image,
      unitType
    ) {

        const minVal = 0;
        const maxVal = 1000000;

        let mainValue = this.props.multibedOverallSiteVolume;

        return (
          <div className="ms-Grid-row" style={css.cpPadding}>


              <div
                style={disable ? { color: 'gray' } : null}
                className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6"
              > {label} </div>
              <div className="ms-Grid-col ms-md12 ms-lg12 ms-xl6 ms-xxl6" style={{ display: 'flex' }}>
                  <SpinButton
                    step={step}
                    min={minVal}
                    max={maxVal}
                    className={'hide-arrows'}
                    disabled={disable}
                    styles={{
                        inputDisabled: {
                            backgroundColor: '#d9d9d6',
                            color: 'white'
                        },
                        arrowButtonsContainerDisabled: {
                            backgroundColor: '#d9d9d6',
                        },
                        spinButtonWrapperDisabled: {
                            backgroundColor: '#d9d9d6'
                        }
                    }}
                    value={`${this.convertUnits(mainValue, unitType) || 0}`}
                    // onIncrement={this.handleParameterValueChange
                    //   .bind(
                    //     this,
                    //     param,
                    //     minVal,
                    //     maxVal,
                    //     step,
                    //     unitType
                    //   )}
                    // onDecrement={this.handleParameterValueChange
                    //   .bind(
                    //     this,
                    //     param,
                    //     minVal,
                    //     maxVal,
                    //     -step,
                    //     unitType
                    //   )}
                    onValidate={this.handleOverallValueOnValidate.bind(
                      this,
                      minVal,
                      maxVal,
                      parseFunc,
                      unitType
                    )}
                  />
                  &nbsp;




              {/*<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6">
                  {label}
              </div>
              <div
                className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6"
                style={{ display: "flex" }}
              >
                  <SpinButton
                    // step={step}
                    max={`${this.convertUnits(maxVal, unitType)}`}
                    min={minVal < 0 ? 0 : `${this.convertUnits(minVal, unitType)}`}
                    value={this.convertUnits(
                      mainValue,
                      unitType,
                      2
                    )}
                    className={"hide-arrows"}
                    disabled={disable}


                    onValidate={this.handleOverallValueOnValidate.bind(
                      this,
                      minVal,
                      maxVal,
                      parseFunc,
                      unitType
                    )}


                  />*/}
                  &nbsp;
                  <PopUpHelper
                    text={text}
                    title={label}
                    image={image}
                  />
              </div>
          </div>
        );
    }


    /**
     * Render the dropdown component element
     * @param {*} label
     * @param {string} text
     * @param {null} image
     * @param {*} legend
     * @param {*} content
     * @param {any} func
     * @param {string} id
     * @param {string} name
     */
    renderDropdownElements(label, text, image, legend, content, func, id, name) {
        return (
            <div className="ms-Grid-row" style={css.padding_class}>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6">{label}</div>
                <div className="ms-Grid-col ms-md12 ms-lg12 ms-xl6 ms-xxl6" style={{ display: "flex" }}>
                    <DefaultButton
                        style={{ minWidth: "100%", maxWidth: "100%" }}
                        text={this.changeFittingNames(legend)}
                        menuProps={{
                            onItemClick: func,
                            items: content
                                .map(item => {
                                    return {
                                        key: item[`${id}`],
                                        text: this.changeFittingNames(item[`${name}`]),
                                    };
                                }),
                        }}
                        className={"primary_darkgreen_ads"}
                    />
                </div>
            </div>
        );
    }

    render() {
        const {
            lbl,
            unit,
            lang,
            content,
            pipeType,
            pipeFitting,
            pipeNominalDiameter
        } = this.props;

        const generatePipes = () => {
            this.props.setPipeParameterValue('pipeNominalDiameter', this.state.newPipeNominalDiameter);
            this.props.switchIsSigningInProcess(true);
            console.log('Start generation');
            this.setState({ showGenerateAlert: false });
            setTimeout(() => {
                this.props.switchIsSigningInProcess(false);
            }, 1000);
            this.props.generatePipeDesign();
        };

        return (
            <React.Fragment>{(
                this.state.showGenerateAlert
                    ? <PopUpHelper
                        title={content[lang].yes}
                        type="alert"
                        show={this.state.showGenerateAlert}
                        modalActions={generatePipes}
                        hideModal={() => this.setState({ showGenerateAlert: false })}
                        text={content[lang].thisWillReplaceCurrentDesign}
                    />
                    : null
            )}
                <div style={{ height: '5px' }} />
                <div style={{ textAlign: 'center' }}>
                    <DefaultButton style={{ backgroundColor: 'green', borderRadius: '15px', color: 'white' }}>
                        {pipeType._name}
                    </DefaultButton>
                </div>
                {this.renderDropdownElements(
                    content[lang].nominalDiameter,
                    'Helper text.',
                    null,
                    pipeNominalDiameter.rawPipeND,
                    pipeSizes.sticksOrFittings,
                    this.handleDropdowns.bind(this, 'pipeNominalDiameter', pipeSizes),
                    'rawPipeND',
                    'rawPipeND',
                    lang
                )}
                {this.renderDropdownElements(
                    content[lang].fitting,
                    'Helper text.',
                    null,
                    this.state.pipeFitting._name,
                    pipeFittings.dataset,
                    this.handleDropdowns.bind(this, 'pipeFitting', pipeFittings),
                    'id',
                    'name',
                    lang
                )}


                { this.props.isMultiBedProject ?
                  this.renderOverallSiteVolume(
                    `${content[lang].overallSiteVolume} (${lbl[unit].cf[lang]})`,
                    500,
                    parseFloat,
                    false,
                    content[lang].enterOverallSiteVolume,
                    null,
                    "cf"
                  ) : null
                }



                {this.renderConstrainedParam(
                    "pipeRequiredVolume",
                    `${content[lang].requiredVolume} (${lbl[unit].cf[lang]})`,
                    1, // Hardcoded value only for test
                    parseFloat,
                    false,
                    content[lang].enterTheStorageVolume,
                    null,
                    1,
                    99999,
                    "cf"
                )}
                {this.renderConstrainedParam(
                    "pipeAvailableLength",
                    `${content[lang].availableLength} (${lbl[unit].ft[lang]})`,
                    1, // Hardcoded value only for test
                    parseFloat,
                    false,
                    content[lang].enterTheAvailableLength,
                    null,
                    1,
                    99999,
                    "ft"
                )}
                {this.renderConstrainedParam(
                    "pipeAvailableWidth",
                    `${content[lang].availableWidth} (${lbl[unit].ft[lang]})`,
                    1, // Hardcoded value only for test
                    parseFloat,
                    false,
                    content[lang].enterTheAvailableWidth,
                    null,
                    1,
                    99999,
                    "ft"
                )}
                {this.renderConstrainedParam(
                    "pipeStoneAbove",
                    pipeFitting._id !== PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID
                        ? `${content[lang].pipeFillAbove} (${lbl[unit].in[lang]})`
                        : `${content[lang].stoneAbove} (${lbl[unit].in[lang]})`,
                    1, // Hardcoded value only for test
                    parseFloat,
                    false,
                    content[lang].enterTheAmountOfStoneFill,
                    null,
                    1,
                    99999,
                    "in"
                )}
                {this.renderConstrainedParam(
                    "pipeStoneBelow",
                    pipeFitting._id !== PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID
                        ? `${content[lang].pipeBeddingBelow} (${lbl[unit].in[lang]})`
                        : `${content[lang].stoneBelow} (${lbl[unit].in[lang]})`,
                    1, // Hardcoded value only for test
                    parseFloat,
                    false,
                    content[lang].enterTheAmountOfStoneBedding,
                    null,
                    1,
                    99999,
                    "in"
                )}
                {this.renderConstrainedParam(
                    "pipeStonePorosity",
                    content[lang].stonePorosity,
                    1,
                    parseFloat,
                    pipeFitting.id !== PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID ? true : false,
                    content[lang].enterStonePorosity,
                    null,
                    0,
                    100,
                    null
                )}
            </React.Fragment>
        );
    }
}

const css = {
    padding_class: {
        paddingTop: '10px',
    }
};

const mapStateToProps = (state) => {
    return {
        pipeType: state.pipeGlobals.pipeType,
        pipeFitting: state.pipeGlobals.pipeFitting,
        pipeSystemType: state.pipeGlobals.pipeSystemType,
        pipeStoneAbove: state.pipeGlobals.pipeStoneAbove,
        pipeStoneBelow: state.pipeGlobals.pipeStoneBelow,
        pipeFlowDirection: state.pipeGlobals.pipeFlowDirection,
        pipeStonePorosity: state.pipeGlobals.pipeStonePorosity,
        pipeRequiredVolume: state.pipeGlobals.pipeRequiredVolume,
        pipeAvailableWidth: state.pipeGlobals.pipeAvailableWidth,
        thermoplasticLiner: state.pipeGlobals.thermoplasticLiner,
        pipeAvailableLength: state.pipeGlobals.pipeAvailableLength,
        pipeNominalDiameter: state.pipeGlobals.pipeNominalDiameter,
        pipeInvertElevation: state.pipeGlobals.pipeInvertElevation,
        pipePerimeterOffset: state.pipeGlobals.pipePerimeterOffset,
        stoneBedMinimumWidth: pipeSelectors.stoneBedMinimumWidth(state),
        stoneBedMinimumLength: pipeSelectors.stoneBedMinimumLength(state),
        sysParam: state.systemParameters,
        isMultiBedProject: ProjectSelectors.isMultiBedProject(),
        multibedOverallSiteVolume: state.multiBed.overallSiteVolume
    };
}

const mapDispatchToProps = {
    generatePipeDesign,
    setPipeParameterValue,
    switchThermoplasticLinter,
    switchIsSigningInProcess,
    setOverallTotal
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PipeParametersComponent);



// WEBPACK FOOTER //
// ./src/components/LeftMenu/SystemParameters/Pipes/pipeParameters.component.js